import { render } from "./MusicAudio.vue?vue&type=template&id=93a20d16"
import script from "./MusicAudio.vue?vue&type=script&lang=js"
export * from "./MusicAudio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__